import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/ui/button'

interface PaginationProps {
    currentPage: number
    totalPages: number
    onPageChange: (page: number) => void
    disabled?: boolean
}

export function Pagination({ currentPage, totalPages, onPageChange, disabled = false }: PaginationProps) {
    const { t } = useTranslation()

    if (totalPages <= 1) {
        return null
    }

    const isFirstPage = currentPage === 0
    const isLastPage = currentPage >= totalPages - 1

    return (
        <div className='flex items-center justify-center gap-4'>
            <Button
                variant='outline'
                size='sm'
                onClick={() => onPageChange(currentPage - 1)}
                disabled={disabled || isFirstPage}
            >
                <ChevronLeft className='h-4 w-4' />
                {t('clients.pagination.previous', 'Anterior')}
            </Button>
            <span className='text-sm text-muted-foreground'>
                {t('clients.pagination.page', 'Página {{current}} de {{total}}', {
                    current: currentPage + 1,
                    total: totalPages,
                })}
            </span>
            <Button
                variant='outline'
                size='sm'
                onClick={() => onPageChange(currentPage + 1)}
                disabled={disabled || isLastPage}
            >
                {t('clients.pagination.next', 'Siguiente')}
                <ChevronRight className='h-4 w-4' />
            </Button>
        </div>
    )
}
